<template>
  <div class="all-caught-up d-flex justify-content-center align-items-center">
    <div class="text-center">
      <span class="text-neutral-300 fw-semibold font-size-md">
        All caught up!
      </span>
      <br />
      <span class="mt-2 text-neutral-300 fw-normal font-size-sm">
        No data, check back later.
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.all-caught-up {
  padding-top: 12.5rem;
}
</style>
